import { AlertMessageService, SigepeAlertMessagesModule } from '@sigepe/sigepe-template';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { DialogDirective } from '@sigepe/dsgov-theme';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { MessageFeedbackComponent } from '@app/shared/components/message-feedback/message-feedback.component';
import { ResultadoAvaliacaoInstitucionalService } from '../services/resultado-avaliacao-institucional.service';

@Component({
	selector: 'sgp-form-alterar-alcance',
	standalone: true,
	providers: [AlertMessageService],
	imports: [
		DialogModule,
		DialogDirective,
		ButtonModule,
		InputNumberModule,
		ReactiveFormsModule,
		SigepeAlertMessagesModule,
		MessageFeedbackComponent
	],
	templateUrl: './form-alterar-alcance.component.html'
})
export class FormAlterarAlcanceComponent implements OnInit, OnDestroy {
	@Input() exibir = false;
	@Output() fechar = new EventEmitter<void>();
	@Output() alcanceAlterado = new EventEmitter<number>();

	private readonly resultadoAvaliacaoService = inject(ResultadoAvaliacaoInstitucionalService);
	private readonly alertMessageService = inject(AlertMessageService);
	private readonly fb = inject(FormBuilder);
	form!: FormGroup;
	submetido = false;

	ngOnInit() {
		this.alertMessageService.dismissAll();
		this.form = this.fb.group({
			idAvaliacaoInstitucional: [null],
			alcance: [null, [Validators.min(1), Validators.max(100)]]
		});
	}

	ngOnDestroy() {
		this.alertMessageService.dismissAll();
	}

	esconderModal(): void {
		this.exibir = false;
		this.fechar.emit();
		this.alertMessageService.dismissAll();
	}

	public salvar(): void {
		this.submetido = true;
		if (this.form.valid) {
			const alcance = this.form.value.alcance;
			const idAvaliacaoInstitucional = this.form.value.idAvaliacaoInstitucional;

			this.resultadoAvaliacaoService.salvarAlcance(alcance, idAvaliacaoInstitucional).subscribe({
				complete: () => {
					this.alertMessageService.success('', 'Alcance alterado com sucesso.', [], undefined, 'msgAlcance');
					this.reiniciarFormulario(alcance, idAvaliacaoInstitucional);
					this.submetido = false;
					this.alcanceAlterado.emit(this.form.value.alcance);
					this.esconderModal();
				},
				error: erro => {
					this.alertMessageService.error('', erro.error.mensagemDetalhe[0], [], undefined, 'msgAlcance');
					this.reiniciarFormulario(alcance, idAvaliacaoInstitucional);
					this.submetido = false;
				}
			});
		}
	}

	reiniciarFormulario(alcance: number, idAvaliacaoInstitucional: number): void {
		this.form.reset();
		this.form.get('alcance')?.setValue(alcance);
		this.form.get('idAvaliacaoInstitucional')?.setValue(idAvaliacaoInstitucional);
	}
}
